<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-modal
      width="100vw"
      v-model:open="open"
      :title="(isEdit ? (isView ? '查看' : '编辑') : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :isViewRoute="isView"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-modal
      width="100vw"
      v-model:open="locationsOpen"
      title="入园点位"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model"
    >
      <locations
        :v-if="open"
        @success="editLocationsSuccess"
        :isEdit="isEdit"
        :isViewRoute="isView"
        :editData="editData"
        :data="tableData"
        :idField="idField"
        :allLocations="allLocations"
      ></locations>
    </a-modal>
    <a-modal
      width="900px"
      v-model:open="bindDeptOpen"
      title="绑定部门"
      :destroyOnClose="true"
      :maskClosable="false"
      @cancel="onBindCancel"
      @ok="onBindOk"
    >
      <a-form-item label="点击绑定部门，输入可搜索">
        <a-select
          v-model:value="selectedDept"
          mode="multiple"
          style="width: 80%"
          placeholder="请选择部门"
          :options="constantToOptions(Enum.dept.value)"
          show-search
          allow-clear
          :filter-option="filterOption"
          @change="handleChange"
        ></a-select>
      </a-form-item>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'publish'">
          {{ codeToText(record.publish, publishState) }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.state, Enum.stateEquipmentType.value) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="handelBindDept(record)"
              :loading="loadingRecord === record"
              v-if="ableBind"
            >
              绑定部门
            </a-button>
            &nbsp;&nbsp;
            <a-button
              @click="showViewModal(record)"
              :loading="loadingRecord === record"
            >
              查看路线
            </a-button>
            &nbsp;&nbsp;

            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableEdit"
            >
              编辑路线
            </a-button>
            &nbsp;&nbsp;
            <a-button
              @click="showLocationsModal(record, true)"
              :loading="loadingRecord === record"
            >
              查看点位
            </a-button>
            &nbsp;&nbsp;
            <a-button
              @click="showLocationsModal(record)"
              :loading="loadingRecord === record"
              v-if="ableEdit"
            >
              编辑点位
            </a-button>
            &nbsp;&nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, watch, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    bindDepart,
    findDepart,
    getAllLocation,
  } from '@/api/car_route'
  import action from './action'
  import locations from './locations'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { yesOrNot, publishState } from '@/utils/common'
  //初始化
  const pageName = '车辆入园路线'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRoute:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRoute:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRoute:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRoute:delete')
  )
  const ableCommit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRoute:bind')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'name',
      label: '名称',
    },
    {
      type: 'select',
      field: 'publish',
      options: constantToOptions(publishState),
      label: '发布状态',
      defaultValue: '',
      'allow-clear': true,
      width: '130px',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '发布状态',
      key: 'publish',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //3、编辑、添加、查看
  const open = ref(false)
  const isEdit = ref(false)
  const isView = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    isView.value = false
    open.value = true
  }
  const showEditModal = async (data) => {
    loadingRecord.value = data
    const detail = data
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      isView.value = false
      open.value = true
    }
  }
  const showViewModal = async (data) => {
    loadingRecord.value = data
    const detail = data
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      isView.value = true
      open.value = true
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }

  //5、绑定部门
  const rowId = ref()
  const selectedDept = ref()
  const bindDeptOpen = ref(false)
  watch(rowId, async () => {
    if (!rowId.value) return
    const res = await findDepart({ id: rowId.value })
    selectedDept.value = res.data.map((item) => item.depart_id)
  })
  function handelBindDept(data) {
    rowId.value = data[idField]
    bindDeptOpen.value = true
  }
  async function onBindOk() {
    const res = await bindDepart({
      id: rowId.value,
      departIds: selectedDept.value.toString(),
    })
    if (res.success) {
      message.success('绑定成功')
      onBindCancel()
    } else {
      message.warn(res.msg)
    }
  }
  function onBindCancel() {
    rowId.value = undefined
    bindDeptOpen.value = false
    selectedDept.value = undefined
  }
  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

  //6、选择点位
  const locationsOpen = ref(false)
  const showLocationsModal = async (data, view = false) => {
    const locations = data.location_id.split(',')
    editData.value = { ...data, locations }
    isEdit.value = true
    isView.value = view
    locationsOpen.value = true
  }

  //获取所有点位
  const allLocations = ref()
  onMounted(async () => {
    const res = await getAllLocation()
    if (res.success) {
      allLocations.value = res.data
    }
  })
  function editLocationsSuccess() {
    fetch()
    locationsOpen.value = false
  }
</script>
